export const Window = () => {
  if (typeof window !== 'undefined') {
    return window;
  }
  return null;
};
